import { IDisneyGenerateOtpRequest, IDisneyGenerateOtpResponse } from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IDisneyGenerateOtpUseCase {
    execute(
        params: IDisneyGenerateOtpRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IDisneyGenerateOtpResponse>;
}

export class DisneyGenerateOtpUseCase implements IDisneyGenerateOtpUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        params: IDisneyGenerateOtpRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IDisneyGenerateOtpResponse> {
        return await this.subscriptionRepository.disneyGenerateOtp(params, apiToken);
    }
}
